import React, { useState, useCallback, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputBase from '@material-ui/core/InputBase'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Paper from '@material-ui/core/Paper'
import classNames from 'classnames'
import { v4 as uuidv4 } from 'uuid'
import FormControl from '@material-ui/core/FormControl'
import { debounce as lodashDebounce } from 'lodash'
import { TextField } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    errorText: {
        position: 'absolute',
        bottom: -22,
        left: 4
    },
    inputBase: {
        width: '100%',
        fontWeight: 400,
        fontSize: 13,
        color: theme.textPrimary
    },
    errorPaper: {
        // borderLeftColor: `${theme.error} !important`
        outline: `1px solid ${theme.error} !important`
    },
    icon: {
        // fontSize: 24
        // color: theme.iconSecondary
    },
    formControl: {
        width: '100%',
        minHeight: 46
    },
    inputPaper: {
        height: '100%',
        background: theme.tertiary,
        padding: '10px 20px',
        // borderLeft: '4px solid transparent',
        borderRadius: theme.borderRadius
        // border: theme.border
    },
    inputLabelContainer: {
        left: '23px',
        top: '-6px'
    },
    inputLabelRoot: {
        fontSize: 11,
        color: theme.textSecondary,
        fontWeight: 400
    },
    inputLabelFocused: {
        color: `${theme.textSecondary} !important`
    },
    inputLabelShrink: {
        transform: 'translate(0, 8.5px) scale(0.9) !important',
        MsTransform: 'translate(0, 8.5px) scale(0.9) !important',
        OTransform: 'translate(0, 8.5px) scale(0.9) !important',
        MozTransform: 'translate(0, 8.5px) scale(0.9) !important',
        WebkitTransform: 'translate(0, 8.5px) scale(0.9) !important',
        fontWeight: 400
    },
    input: {
        '&::placeholder': {
            fontSize: 12,
            color: 'rgba(0, 0, 0, 1)'
        }
    }
}))

function CustomInput(props, ref) {
    const classes = useStyles()
    const id = uuidv4()

    const {
        setValue,
        startIcon,
        endIcon,
        label,
        placeholder,
        disabled,
        onEnter,
        onKeyDown,
        isError,
        type,
        value,
        inputProps,
        multiline,
        autoFocus,
        debounce,
        onKeyPress,
        defaultValue = '',
        errorText,
        errorInsteadOfLabel,
        size,
        variant = 'outlined',
        onBlur,
        ...restProps
    } = props
    const restClasses = { ...restProps }.className
    delete restProps.className

    const [text, setText] = useState(value || defaultValue)

    const sendValue = debounce
        ? useCallback(lodashDebounce(setValue, debounce, true), [])
        : setValue
        ? setValue
        : () => {}

    useEffect(() => setText(value || defaultValue), [value])

    const onChange = e => {
        setText(e.target.value)
        sendValue(e.target.value)
    }

    return (
        <FormControl
            className={classNames({
                [`${classes.formControl}`]: true,
                [`${restClasses}`]: restClasses
            })}>
            <TextField
                ref={ref}
                {...restProps}
                fullWidth
                variant="outlined"
                label={isError && errorInsteadOfLabel ? errorText : label}
                autoFocus={autoFocus}
                onChange={onChange}
                onKeyDown={ev => {
                    if (ev.keyCode === 13 && onEnter) {
                        onEnter(ev.target.value)
                    }

                    if (onKeyDown) {
                        onKeyDown(ev)
                    }
                }}
                size={size}
                type={type}
                value={text}
                disabled={disabled}
                placeholder={placeholder}
                inputProps={inputProps}
                multiline={multiline}
                onKeyPress={onKeyPress}
                onBlur={onBlur}
                InputProps={{
                    endAdornment: endIcon && (
                        <InputAdornment position="end">
                            {endIcon({
                                className: classes.icon
                            })}
                        </InputAdornment>
                    ),
                    startAdornment: startIcon && (
                        <InputAdornment position="start">
                            {startIcon({
                                className: classes.icon
                            })}
                        </InputAdornment>
                    ),
                    style: {
                        borderRadius: 7,
                        paddingRight: endIcon ? 40 : undefined
                    },
                    ...restProps.InputProps
                }}
                error={isError}
                helperText={
                    isError && !errorInsteadOfLabel ? errorText : undefined
                }
            />
        </FormControl>
    )
}

export default React.forwardRef(CustomInput)

// LEGACY, DO NOT REMOVE PLEASE
// return (
//     <FormControl
//         className={classNames({
//             [`${classes.formControl}`]: true,
//             [`${restClasses}`]: restClasses
//         })}>
//         <Paper
//             elevation={0}
//             className={classNames({
//                 [`${classes.errorPaper}`]: isError,
//                 [`${classes.inputPaper}`]: true
//             })}>
//             {label && (
//                 <InputLabel
//                     classes={{
//                         formControl: classes.inputLabelContainer,
//                         root: classes.inputLabelRoot,
//                         shrink: classes.inputLabelShrink,
//                         focused: classes.inputLabelFocused
//                     }}
//                     htmlFor={id}>
//                     {label}
//                 </InputLabel>
//             )}
//             <InputBase
//                 {...restProps}
//                 autoFocus={autoFocus}
//                 className={classes.inputBase}
//                 classes={{ input: classes.input }}
//                 onChange={onChange}
//                 onKeyDown={ev => {
//                     if (ev.keyCode === 13 && onEnter) {
//                         onEnter(ev.target.value)
//                     }

//                     if (onKeyDown) {
//                         onKeyDown(ev)
//                     }
//                 }}
//                 type={type}
//                 id={id}
//                 value={text}
//                 disabled={disabled}
//                 placeholder={placeholder}
//                 inputProps={inputProps}
//                 multiline={multiline}
//                 onKeyPress={onKeyPress}
//                 startAdornment={
//                     startIcon && (
//                         <InputAdornment position="start">
//                             {startIcon({
//                                 className: classes.icon
//                             })}
//                         </InputAdornment>
//                     )
//                 }
//                 endAdornment={
//                     endIcon && (
//                         <InputAdornment position="end">
//                             {endIcon({
//                                 className: classes.icon
//                             })}
//                         </InputAdornment>
//                     )
//                 }
//             /* endAdornment={
//             <InputAdornment position="end" style={{ display: (user.password && user.password.length === 0) && 'none' }} >
//                 {
//                     showPassword
//                         ? <VisibilityOffIcon onClick={ toggleShowPassword } className={ classes.showIcon } />
//                         : <VisibilityIcon onClick={ toggleShowPassword } className={ classes.showIcon } />
//                 }
//             </InputAdornment>
//         } */
//             />

//             {/* <TextField
//                 className={classes.inputBase}
//                 onChange={e => setValue(e.target.value)}
//                 {...restProps}
//                 InputProps={{
//                     className: classes.inputBase,
//                     style: { paddingTop: !label ? 7 : 12 },
//                     disableUnderline: true,
//                     startAdornment: startIcon &&
//                         <InputAdornment
//                             style={{ transform: 'translateY(-2px)' }}
//                             position="start"
//                         >
//                             {startIcon({
//                                 className: classes.icon
//                             })}
//                         </InputAdornment>
//                 }}
//             /> */}
//         </Paper>
//         {errorText && isError ? (
//             <FormHelperText className={classes.errorText} error={isError}>
//                 {errorText}
//             </FormHelperText>
//         ) : null}
//     </FormControl>
// )
